// Post Model
import { Model } from '@vuex-orm/core';

export default class Reminder extends Model {
    static entity = 'reminder';

    static fields() {
        return {
            id: this.attr(null),
            event_id: this.attr(null),
            product_id: this.attr(null),
            user_id: this.attr(null),
            duration: this.attr(null),
            unit: this.attr(null),
        };
    }

    static resource(type) {
        switch (type) {
            case 'product':
                return 'courses';
            case 'event':
                return 'events';
            default:
                return 'unknown type provided';
        }
    }

    static apiConfig = {
        actions: {
            store(id, type, reminders) {
                return new Promise((resolve, reject) => {
                    this.post(`/api/v3/${this.model.resource(type)}/${id}/reminders`, { reminders, type}, {
                        dataTransformer: (response) => {
                            Reminder.delete(item => item.id == null);
                            return response.data.data;
                        },
                    }).then((response) => {
                        resolve(response.response.data.data);
                    }).catch((error) => {
                        reject(error.response.data);
                    });
                });
            },

            fetchAllReminders(id, type) {
                const params = new URLSearchParams();
                params.append('type', type);
                return new Promise((resolve) => {
                    this.get(`/api/v3/${this.model.resource(type)}/${id}/reminders`, {
                        params,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    });
                });
            },

            deleteAllReminders(id, type) {
                const params = new URLSearchParams();
                params.append('type', type);
                return new Promise((resolve) => {
                    this.delete(`/api/v3/${this.model.resource(type)}/${id}/reminders`, {
                        params,
                        dataTransformer: response => response.data.data,
                    }).then((response) => {
                        resolve(response);
                    });
                });
            },
        },
    }
}

window.Reminder = Reminder;
